import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'


export default function reportForm() {

  const devices = ref([])

  const camps = ref([])
  const suctions = ref([])
  const dumps = ref([])


  ReportService.getDevicesOptions({
    type:'device',
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))


  ReportService.getAreasOptions({
    type:'geofence',
    user: store.state.auth.userData.id,
    cols: 'id,name,category',
    categoryIn: 'CAMP,SUCTION,DUMP'
  }).then(response => {

    response.data.map(area => {
      let ref = area.category.toLowerCase()
      try {
        eval(`${ref}s`).value.push(area)
      }
      catch (e) {
      }
    })
  })


  return {
    devices,
    camps,
    suctions,
    dumps,
  }
}
